require('./datatable/handleAjaxErrors');
require('./datatable/translations');

// Re-init common view on datatable init and on pagination change
$(() => {

    $(document).on('init.dt', (e, settings) => {
        // Load js
        common.View.reinit();

        addDuskToTable();
        initPerformOnClickForActions();

        // Fix loader position after data has been loaded
        $('.dataTables_processing').attr('style', 'top: 50% !important');

        let table = $('#dataTableBuilder').DataTable();
        table.on('draw', () => {
            // Datatable ready loading
            common.View.reinit();

            addDuskToTable();
            initPerformOnClickForActions();
        });
    });

    function addDuskToTable() {
        let datatableBuilderThead = $('#dataTableBuilder > thead').children('tr'),
            datatableBuilderTrs = $('#dataTableBuilder > tbody > tr'),
            datatableBuilderTds = $('#dataTableBuilder > tbody > tr > td');

        datatableBuilderThead.children('th, td').each(function (index_th, val_th) {
            let duskTh = $(val_th).attr('dusk');

            datatableBuilderTrs.each((index_tr, val_tr) => {
                if ($(val_tr).attr('id')) {
                    $(val_tr).attr('dusk', 'row' + '-' + $(val_tr).attr('id'));
                }
            });

            datatableBuilderTds.each((index_td, val_td) => {
                if ($(val_td).index() === index_th) {
                    $(val_td).attr('dusk', duskTh);
                }
            });
        });
    }

    function initPerformOnClickForActions()
    {
        $('#dataTableBuilder *[data-perform-on-row-click="true"]')
            .closest('tr')
            .addClass('hasActionWhichPerformsOnRowClick')

            .find('td:not(.actions)')
                .unbind('click')
                .click(event => {
                    $(event.currentTarget).closest('tr').find('*[data-perform-on-row-click="true"]')[0].click();
                })
                .end();
    }
});
